import script from "./permissions.vue?vue&type=script&setup=true&lang=js"
export * from "./permissions.vue?vue&type=script&setup=true&lang=js"

import "./permissions.vue?vue&type=style&index=0&id=58b7fe5a&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58b7fe5a"]])

export default __exports__